interface LockIconProps {
  readonly color?: string
  readonly size?: number
}

export function LockIcon({ color = 'currentColor', size = 16 }: LockIconProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" fill={color} stroke="none" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" fill="none" stroke={color} />
    </svg>
  )
}
